import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EbEmployeeDashboardDetailsService } from '../../../service/eb-employee-dashboard-details/eb-employee-dashboard-details.service';
import { EBClaimStatusVm } from '../../../model/eb-claim-status-vm';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { EbDashboardEmailService } from '../../../service/eb-dashboard-email/eb-dashboard-email.service';

@Component({
  selector: 'app-dialog-eb-claim-status-details',
  templateUrl: './dialog-eb-claim-status-details.component.html',
  styleUrls: ['./dialog-eb-claim-status-details.component.scss']
})
export class DialogEbClaimStatusDetailsComponent  implements OnInit {

  claimStatusList : EBClaimStatusVm[] = [];
  claimStatusTitles = {
    completed : 'COMPLETED',
    pending : 'PENDING',
    decline : 'DECLINE',
    medicalReview : 'MEDICAL REVIEW',
    review : 'REVIEW',
    additionalDocRequired : 'ADDITIONAL DOCUMENT REQUIRED',
    approved : 'APPROVED & READY FOR PAYMENT',
    sentForPayment : 'SENT FOR PAYMENT'
  }

  constructor(
    public dialogRef: MatDialogRef<DialogEbClaimStatusDetailsComponent>,
    private employeeDashboardService: EbEmployeeDashboardDetailsService,
    private ebDashboardEmailService: EbDashboardEmailService,
    private messageService : MessageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.getClaimStatusByClaimEntryId(data.claimEntryId)
  }

  ngOnInit() {}

  getClaimStatusByClaimEntryId(claimEntryId: number){
    this.employeeDashboardService.getClaimStatusDetails(claimEntryId).subscribe(
      (res : EBClaimStatusVm[]) => {
        this.claimStatusList = res;
      },
      error => {
        this.messageService.show(error.error.message, "error");
      }
    )
  }

  onCancel() {
    this.dialogRef.close('no');
  }

  getSummary(summary:string){
    if(!summary)
      return null;

    let items = summary.split(':');
    if(items.length > 1)
      return '<b>'+ items[0] +' : </b>' + items[1];
    else
      return summary;
  }

  sendPaymentExplanationEmail(){
    this.messageService.confirm().then(con => {
      if (con.value === true) {
        this.ebDashboardEmailService.sendPaymentExplanationEmail({enrolId: this.data.enrolId, claimNo: this.data.claimNumber})
        .subscribe((res: any) => {
            this.messageService.show(this.messageService.msgEmailSendSuccess, "success");
          },
          error => {
            this.messageService.show(error.error.message, "error");
          }
        );
      }
    });
  }
}

